// extracted by mini-css-extract-plugin
export default {"wrapper":"GetStarted_wrapper__j7RJX","tronLink":"GetStarted_tronLink__bFcKJ","noPrimary":"GetStarted_noPrimary__FuQWM"};